module.exports = __webpack_public_path__ + "baf19f4d3286704d9404bf2b25df82fc.pdf";